/* eslint-disable */
/*
 * Top level customization component.
 * 
 * This just contains <Lexicon> for now, but eventually might contain
 * language model, acoustic model, or other customizations.
 */

import React, { Component } from 'react'
import Lexicon from './lexicon'
import Customization from './customization'

class Customize extends Component {
  constructor() {
    super()

    this.state = {
      showing: 'lexicons'
    }
  }
  
  render() {
    return (
      <div className='re is-main'>
	<button onClick={(e) => { e.preventDefault(); this.setState({showing: 'lexicons'}); }}>Lexicons</button>
	<button onClick={(e) => { e.preventDefault(); this.setState({showing: 'customizations'}); }}>Customizations</button>
	{ this.state.showing === 'lexicons' ? <Lexicon /> : <Customization /> }
      </div>
    )
  }
}

export default Customize
